import { securedFetch } from "../../auth/authService";

const THEME_API = '/api1/report-theme';

/**
 * Get all themes for the current user
 */
export function listThemes() {
    return securedFetch(THEME_API, null, 'GET');
}

/**
 * Get a single theme by ID
 * @param {number} id - Theme ID
 */
export function getTheme(id) {
    return securedFetch(`${THEME_API}/${id}`, null, 'GET');
}

/**
 * Create a new theme
 * @param {Object} themeDto - Theme data with name, description, and sections
 */
export function createTheme(themeDto) {
    return securedFetch(THEME_API, themeDto, 'POST');
}

/**
 * Update an existing theme
 * @param {number} id - Theme ID
 * @param {Object} themeDto - Updated theme data
 */
export function updateTheme(id, themeDto) {
    return securedFetch(`${THEME_API}/${id}`, themeDto, 'POST');
}

/**
 * Delete a theme (soft delete)
 * @param {number} id - Theme ID
 */
export function deleteTheme(id) {
    return securedFetch(`${THEME_API}/${id}`, null, 'DELETE');
}

/**
 * Duplicate an existing theme
 * @param {number} id - Theme ID to duplicate
 */
export function duplicateTheme(id) {
    return securedFetch(`${THEME_API}/${id}/duplicate`, null, 'POST');
}
